import Papa from "papaparse";
import React from "react";
import { ModalType } from "../../../config/ModalTypes";
import useModal from "../../../hooks/useModal";
import FileSelect from "./FileSelect";

interface Props<T> {
  data: T[] | null;
  onComplete: (data: T[]) => void;
}

export default function CsvParser<T>(props: Props<T>) {

  const showModal = useModal()

  return (
    <FileSelect
      accept=".csv"
      selectedFileName={props.data?.length ? `${props.data.length} rows parsed` : undefined}
      onChange={async (file) => new Promise<void>((resolve) => {
        Papa.parse<Record<string, string>>(file, {
          header: true,
          skipEmptyLines: true,
          complete: (r) => {
            props.onComplete(r.data as T[]);

            if (!r.data.length) {
              showModal({
                type: ModalType.Error,
                text: "The CSV file was parsed successfully but contains no data rows. Please ensure your CSV file is properly formatted and try again."
              });
            }

            resolve();
          },
          error: (err) => {
            showModal({
              type: ModalType.Error,
              text: "Failed to parse CSV file. Please ensure the file is properly formatted and try again."
            });

            console.log("Error parsing CSV file:", err);
            resolve();
          }
        });
      })}

    />
  )
}